export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-purple-900 to-pink-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/e0a38c2585532f9a804a48c9264dc408.png" 
              alt="KIMURAMA WORKS" 
              className="h-12 mb-6"
            />
            <p className="text-base font-medium text-white/90 leading-relaxed mb-6">
              AIとSNSの力で、あなたのビジネスを次のステージへ。<br />
              実践的なコンサルティングで成果を実現します。
            </p>
            <div className="flex gap-4">
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://note.com/mako3978" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-article-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">クイックリンク</h3>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => scrollToSection('services')}
                className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer text-left"
              >
                サービス
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer text-left"
              >
                私について
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer text-left"
              >
                お客様の声
              </button>
              <button
                onClick={scrollToTop}
                className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer text-left"
              >
                ブログ
              </button>
            </div>
          </div>

          {/* Photo */}
          <div className="flex justify-center md:justify-end">
            <div className="w-40 h-56 sm:w-48 sm:h-64 lg:w-52 lg:h-72 rounded-lg overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-500">
              <img 
                src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/83ac659fa307c4f5e1f7dddba24178f6.png" 
                alt="木村まこ" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="border-t border-white/20 pt-8 mb-8">
          <h3 className="text-lg font-bold mb-6">お問い合わせ</h3>
          <div className="flex flex-col sm:flex-row gap-6">
            <a 
              href="mailto:mk.oku@kimurama.com"
              className="flex items-center gap-3 text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-xl"></i>
              <span>mk.oku@kimurama.com</span>
            </a>
            <button
              onClick={() => scrollToSection('contact')}
              className="inline-flex items-center gap-2 bg-white text-purple-900 px-6 py-3 rounded-full font-semibold text-base hover:bg-white/90 transition-all duration-300 cursor-pointer whitespace-nowrap w-fit"
            >
              <span>お問い合わせフォーム</span>
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm font-medium text-white/80">
              © 2025 KIMURAMA WORKS. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}